import { c as _c } from "react/compiler-runtime";
import { MembersDefaultMessage } from "@/app/(main)/(club)/mes-clubs/[id]/components/modal/event/read/default-message/members-default-message";
import ProfilePicture from "@/components/user/profile-picture";
import { EventRead, HonoredMember } from "@/TS/Interfaces/global_interfaces";
interface EventReadHonoredMembersProps {
  event: EventRead;
  title: string;
  type: "honoredMembers" | "requests" | "absents";
  defaultMessage: string;
}
export const EventReadHonoredMembers: React.FC<EventReadHonoredMembersProps> = t0 => {
  const $ = _c(8);
  const {
    event,
    title,
    type,
    defaultMessage
  } = t0;
  const members = event[type as keyof EventRead] as Array<HonoredMember>;
  const t1 = `${title} (${members.length})`;
  let t2;
  if ($[0] !== t1) {
    t2 = <p className="font-bold mb-2 uppercase">{t1}</p>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== defaultMessage || $[3] !== members) {
    t3 = members.length > 0 ? <><div className="flex flex-col md:flex-row md:justify-between gap-4 md:gap-8">{members.slice(0, 2).map(_temp)}</div></> : <MembersDefaultMessage defaultMessage={defaultMessage} />;
    $[2] = defaultMessage;
    $[3] = members;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
function _temp(member, index) {
  return <div key={index} className="flex-1"><div className="flex items-center gap-2"><ProfilePicture size={32} mobileSize={45} className="md:!text-[14px] text-base" firstName={member.firstName} lastName={member.lastName} src={member.avatar?.urls?.avatar_md} alt={`${member.firstName[0]}. ${member.lastName}`} /><p className="font-bold h-fit">{member.firstName} {member.lastName}</p></div></div>;
}